/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type NoPets_account = {
    readonly hasAnimals: boolean;
    readonly " $refType": "NoPets_account";
};
export type NoPets_account$data = NoPets_account;
export type NoPets_account$key = {
    readonly " $data"?: NoPets_account$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"NoPets_account">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NoPets_account",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAnimals",
            "storageKey": null
        }
    ],
    "type": "Account",
    "abstractKey": null
} as any;
(node as any).hash = 'acce02062a8ba8aae4f5d4bfea367c7e';
export default node;
